import React from "react";
import type { ApiNotificationRule, AlertFrequency } from "../types";
import { Badge } from "@/components/ui/badge";
import { formatDate } from "@/utils/date";
import MobileListWrapper from "@/components/mobile-list-wrapper";
import { useTranslation } from "react-i18next";
import { alertTypeBadgeVariant } from "./alerts-columns";

interface ListContentProps {
  data: ApiNotificationRule[];
  isLoading: boolean;
  className?: string;
  page: number;
  pageCount: number;
  onPageChange: (page: number) => void;
  emptyListComponent: React.ReactElement;
}

const ListContent = ({
  data,
  isLoading,
  className,
  page,
  pageCount,
  onPageChange,
  emptyListComponent,
}: ListContentProps) => {
  const { t } = useTranslation();

  const frequencyLabel = (frequency: AlertFrequency): string => {
    switch (frequency) {
      case "immediate":
        return t("modules.alerts.keys.frequency_immediate");
      case "weekly":
        return t("modules.alerts.keys.frequency_weekly");
      case "monthly":
        return t("modules.alerts.keys.frequency_monthly");
    }
  };

  const alertTypeLabel = (alert: ApiNotificationRule): string => {
    switch (alert.alert_type) {
      case "new_dilemma":
        return t("modules.alerts.keys.alert_type_new_dilemma");
      case "focus_dilemma":
        return t("modules.alerts.keys.alert_type_focus_dilemma");
      case "admin_action":
        return t("modules.alerts.keys.alert_type_admin_action");
    }
  };

  return (
    <MobileListWrapper
      data={data}
      isLoading={isLoading}
      className={className}
      page={page}
      pageCount={pageCount}
      onPageChange={onPageChange}
      emptyListComponent={emptyListComponent}
      onItemClick={() => {}}
      renderItem={(alert) => (
        <>
          <div className="flex items-center justify-between gap-2">
            <h3 className="font-semibold truncate">{alert.title}</h3>
            <Badge variant={alertTypeBadgeVariant(alert.alert_type)}>
              {alertTypeLabel(alert)}
            </Badge>
          </div>
          <div className="flex items-center justify-between mt-1">
            <span className="text-sm text-gray-500">
              {frequencyLabel(alert.frequency)}
            </span>
            <span className="text-sm text-gray-500">
              {formatDate(alert.created_at)}
            </span>
          </div>
        </>
      )}
    />
  );
};

export default ListContent;
